// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';
import {CustomerType} from '../../enum/customer-type';

export const MergeCustomerStatus = t.struct({
    businessType: t.maybe(CustomerType),
    isModalShown: t.Boolean,
    isMergeCustomerSelected: t.Boolean,
    isMergeRequestErrorMessageShown: t.Boolean,
    isMergeRequestSuccessMessageShown: t.Boolean,
    isMergeRequestFullPageLoaderShown: t.Boolean
}, {
    defaultProps: {
        businessType: null,
        isModalShown: false,
        isMergeCustomerSelected: false,
        isMergeRequestErrorMessageShown: false,
        isMergeRequestSuccessMessageShown: false,
        isMergeRequestFullPageLoaderShown: false
    },
    name: 'MergeCustomerStatus',
    strict: true
});
